import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CircleNotch, ArrowLeft } from "@phosphor-icons/react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError("New password must be at least 8 characters.");
    if (next !== confirm) return setError("New password and confirmation do not match.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated successfully");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 sm:p-8" data-testid="change-password-page">
      <button
        onClick={() => navigate(-1)}
        className="mb-6 flex items-center gap-1.5 text-sm font-medium text-[#6D6D70] transition-colors hover:text-[#032852]"
        data-testid="change-password-back"
      >
        <ArrowLeft size={16} /> Back
      </button>

      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#569A1F]">Account</p>
      <h1 className="mt-2 font-heading text-3xl font-black tracking-tight text-[#032852]">Change password</h1>
      <p className="mt-2 text-sm text-[#6D6D70]">Update the password used to sign in to your account.</p>

      <form onSubmit={submit} className="mt-8 max-w-md space-y-5 rounded-sm border border-[#E4E4E7] bg-white p-6">
        <div className="space-y-2">
          <Label htmlFor="cur" className="text-xs font-bold uppercase tracking-wide text-[#52525B]">
            Current password
          </Label>
          <Input id="cur" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="rounded-sm" data-testid="current-password-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="new" className="text-xs font-bold uppercase tracking-wide text-[#52525B]">
            New password
          </Label>
          <Input id="new" type="password" required value={next} onChange={(e) => setNext(e.target.value)} className="rounded-sm" data-testid="new-password-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="conf" className="text-xs font-bold uppercase tracking-wide text-[#52525B]">
            Confirm new password
          </Label>
          <Input id="conf" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-sm" data-testid="confirm-password-input" />
        </div>

        {error && (
          <p className="rounded-sm border border-[#EF4444]/30 bg-[#EF4444]/5 px-3 py-2 text-sm text-[#EF4444]" data-testid="change-password-error">
            {error}
          </p>
        )}

        <Button type="submit" disabled={loading} className="rounded-sm bg-[#569A1F] font-semibold text-white hover:bg-[#457d18]" data-testid="change-password-submit">
          {loading ? <CircleNotch size={18} className="animate-spin" /> : "Update password"}
        </Button>
      </form>
    </div>
  );
}
